var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("Uh oh... that shouldn't have happened")]),_c('div',{staticClass:"error-stack"},[_vm._v(_vm._s(_vm.error.stack))])])}
var staticRenderFns = []

export { render, staticRenderFns }